import { Routes } from '@angular/router';
import { authGuard, notLoggedInGuardGuard } from '@app/guards';

export const routes: Routes = [
    {
        path: '',
        canActivateChild: [authGuard],
        loadChildren: () =>
            import('./tabs/tabs.routes').then((m) => m.routes),
    },
    {
        path: 'login',
        canActivate: [notLoggedInGuardGuard],
        loadComponent: () =>
            import('./pages/login/login.page').then(m => m.LoginPage),
    },
    {
        path: '**',
        redirectTo: '',
    },
];
